import { useEffect, useState } from "react";
import ordini_fetch from "../fetch/ordini_fetch";
import PaginazioneTitoloPulsanteCrea from "../riutilizabili/PaginazioneTitoloPulsanteCrea";
import RicercaOrdini from './RicercaOrdini.js';
import CampiOrdini from './CampiOrdini.js';
import TabellaPaginazione from "../riutilizabili/TabellaPaginazione.js";
import QuestionModal from "../riutilizabili/QuestionModal.js";
import { format, set } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import InfoModal from "../riutilizabili/InfoModal.js";
import View from "./View.js";

export default function Ordini() {
    const [arrayOrdini , setArrayOrdini] = useState([]);
    const [viewOrdine , setViewOrdine] = useState(false)
    const [editOrdine , setEditOrdine] = useState({})
    const [inputsFiltra , setInputsFiltra] = useState({})
    const [inputsCrea , setInputsCrea] = useState({})
    const [viewCrea , setViewCrea] = useState(false);
    const [viewModifica , setViewModifica] = useState(false);
    const [error, setError] = useState({});

    const [pageTot , setPageTot] = useState(0);
    const [pageSize , setPageSize] = useState(20);
    const [page , setPage] = useState(1);
    const [azzeraVar , setAzzeraVar] = useState(0)
    const [fu , setFu] = useState(0)

    useEffect(()=>{
        readOrdini()
    },[])
    
    const azzeraFiltra = async () => {
        const ordini = await ordini_fetch.getAll({
            pageSize ,
            page ,
        })
        setInputsFiltra({})
        setArrayOrdini(ordini.data.data)
        setPageTot(ordini.data.pageTot)
        setFu(fu+1)
    }

    const readOrdini = async (params={})=> {
        const ordini = await ordini_fetch.getAll({
            pageSize ,
            page ,
            ...inputsFiltra,
            ...params
        })

        setArrayOrdini(ordini.data.data)
        setPageTot(ordini.data.pageTot)
        setFu(fu+1)
    }

    const readOrdine = async (id)=> {
        const ordine = await ordini_fetch.get({id})
        setViewOrdine(ordine.data)
    }

    const readEditOrdine = async (id)=> {
        const ordine = await ordini_fetch.get({id})
       //console.log(ordine.data , ' ordines');
        
        setEditOrdine(ordine.data)
        setViewModifica(true)
    }

    const creaOrdine = async (stato) => {
        if (stato) {
            try {
                await ordini_fetch.create(inputsCrea)
                await readOrdini()
                setInputsCrea({})
                setError({})
            } catch (error) {
                
            }
    
        }
        setViewCrea(false)
    }

    const modificaOrdine = async (stato) => {
        if (stato) {
            try {
                await ordini_fetch.create(editOrdine)
                await readOrdini()
                setEditOrdine({})
                setError({})
            } catch (error) {
                
            }
            
        }
        setViewModifica(false)
    }

    const handleChange = (key, value) => {
       //console.log('gg', value , key);
        if (!value) {
            const updatedInputsFiltra = { ...inputsFiltra };
            delete updatedInputsFiltra[key]; 
            delete updatedInputsFiltra.descrizione; 
            delete updatedInputsFiltra.rifInterno; 
            setInputsFiltra(updatedInputsFiltra);
        }
        setInputsFiltra(prevState => ({
            ...prevState,
            [key]: value
        }));
        //readOrdini({[key]: value})
    }

    const columns = [
        {
            id: 1,
            label: 'Richiesto da',
            nome: 'utente.nome',
            altCol: (item) => item.utente?.username || '',
        },
        {
            id: 1,
            label: 'Codice articolo',
            nome: 'utente.nome',
            altCol: (item) => item.prodotto?.rifInterno || '',
        },
        {
            id: 2,
            label: 'Articolo',
            nome: 'prodotto.nome',
            altCol: (item) => {
                const descrizione = item.prodotto?.descrizione || '';
                return (
                    <span title={descrizione}>
                        {descrizione.length > 41 ? descrizione.slice(0, 37) + '...' : descrizione}
                    </span>
                );
            },
        },
        {
            id: 2,
            label: 'Fornitore',
            nome: 'fornitore.nome',
            altCol: (item) => item.fornitore?.viewName || '',
        },
        {
            id: 3,
            label: 'quantità',
            nome: 'qt',
        },
        {
            id: 4,
            label: 'Data richiesta',
            nome: 'dataCreate',
            altCol: (item) => format(item.dataCreate, "dd-MM-yyyy HH:mm"),
        },
        {
            id: 5,
            label: 'Data per cui è richiesto il articolo',
            nome: 'dataRichiestaPer',
        },
        {
            id: 7,
            label: 'Data ordine',
            nome: 'dataOrdine',
        },
        {
            id: 6,
            label: 'Data arrivo previsto',
            nome: 'dataArrivoPrev',
        },
        {
            id: 6,
            label: 'Ordinato da',
            nome: 'ordinatoDa',
            altCol: (item) => item.ordinatoDa?.username || '',
        },
    ];

    const impaginazione = async (impaginazione)=> {
        setPage(impaginazione.numeroPag)
        setPageSize(impaginazione.pageSize)
        if ( page !==impaginazione.numeroPag ||  pageSize !== impaginazione.pageSize) {
            await readOrdini({pageSize:impaginazione.pageSize , page : impaginazione.numeroPag , ...inputsFiltra })
            setAzzeraVar(0)
        }
    }

    const Pulsanti = ({element}) => {

        return(
            <td className='d-flex  justify-content-around p-0 m-0 py-3'>
                <button className='btn py-2 my-1 button_fix' >
                    <FontAwesomeIcon className='p-0 m-0 text_bluDue' icon={faEye} onClick={()=>setViewOrdine(element)} />
                </button>
                <button className='btn py-2 my-1 button_fix' >
                    <FontAwesomeIcon className='p-0 m-0 text_bluDue' icon={faEdit} onClick={()=>readEditOrdine(element.id)} />
                </button>
            </td>
        )
    }
    

    return(
        <div className='p-2'>
            <PaginazioneTitoloPulsanteCrea
              titolo={'Richieste ordini'}
              funCrea={() =>setViewCrea(true)}
            />

            <div className='align-items-center d-flex flex-column pt-4' >
                <div className='border_filtra p-3 mx-4 px-4' style={{width: '96%'}}>
                    <RicercaOrdini onChange={handleChange} values={inputsFiltra} filtra={readOrdini} azzeraFiltra={azzeraFiltra} />
                </div>
                <div className='d-flex justify-content-around w-100' >
                    <div className='m-5 w-100 pe-2'>
                        <TabellaPaginazione
                            dati={arrayOrdini} 
                            colonne={columns} 
                            totalePag={pageTot} 
                            azzera={azzeraVar} 
                            impaginazione={impaginazione}
                            Pulsanti={Pulsanti}
                            fu={fu}
                        />
                    </div>
                </div>
            </div>

            {viewCrea &&
                  <QuestionModal
                  title='Crea ordine'
                  text={
                  <CampiOrdini 
                    onChange={(name , value)=> setInputsCrea(values => ({ ...values, [name]: value }))}
                    values={inputsCrea}
                    onChangeError={(error)=> setError(Object.keys(error))}
                    error={error}
                  />
                }
                  YesLabel = 'Crea'
                  onClose = {creaOrdine}

                />}

            {viewModifica &&
                  <QuestionModal
                  title='Modifica ordine'
                  text={
                  <CampiOrdini 
                    onChange={(name , value)=> setEditOrdine(values => ({ ...values, [name]: value }))}
                    values={editOrdine}
                    onChangeError={(error)=> setError(Object.keys(error))}
                    error={error}
                  />
                }
                  YesLabel = 'Salva'
                  onClose = {modificaOrdine}

                />}

                <InfoModal
                    title={'Dettagli ordine'}
                    text={
                        <View ordineId={viewOrdine.id} />
                    }
                    canClose
                    handleClose={() => setViewOrdine(false)}
                    show={!!viewOrdine}
                    classi={'modal-xxl'}
                />
        </div>
    )
    
}